import React, { useMemo } from 'react';
import { useMedicalProfileDirectives } from '../../../../../../hooks/api/useMedicalProfileDirectives';
import CodeStatusFormFields, {
    formValueToUpsertProfileCodeStatusRequest,
    getDefaultFromValue,
} from '../../../../../shared/Directives/CodeStatusFormFields';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { Form } from '../../../../../v2BaseComponents/Form';
import SideDrawerFormContainer from '../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import { getIntl } from '../../../../../../utils/intl';

const intl = getIntl('EditCodeStatusSideDrawerContent', {
    save: 'Save',
    cancel: 'Cancel',
});

export type EditCodeStatusSideDrawerContentOwnProps = {
    medicalProfileId: string;
    onClose: (force: boolean) => void;
};

export type EditCodeStatusSideDrawerContentProps = EditCodeStatusSideDrawerContentOwnProps;

const EditCodeStatusSideDrawerContent: React.FC<EditCodeStatusSideDrawerContentProps> = ({
    medicalProfileId,
    onClose,
}) => {
    const { isLoadingCodeStatus, codeStatus, updateCodeStatus, isUpdatingCodeStatus } = useMedicalProfileDirectives({
        medicalProfileId: medicalProfileId,
        onCodeStatusUpdateSuccess: () => onClose(true),
    });
    const initialValue = useMemo(() => getDefaultFromValue(codeStatus), [codeStatus]);
    const isLoading = isLoadingCodeStatus || isUpdatingCodeStatus;
    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <Form
                    fillContainer
                    initialValues={initialValue}
                    onSubmit={(values) => {
                        const upsertRequest = formValueToUpsertProfileCodeStatusRequest(values, codeStatus);
                        updateCodeStatus(upsertRequest);
                    }}
                    isDisabled={isLoading}
                    forceStackFields
                >
                    {({ isSubmitting, handleSubmit, values, setFieldValue }) => {
                        return (
                            <SideDrawerFormContainer
                                isDisabled={isSubmitting || isLoading}
                                onSubmit={handleSubmit}
                                onCancel={() => onClose(true)}
                                saveText={intl('save')}
                                saveIcon="Check"
                            >
                                <CodeStatusFormFields values={values} setFieldValue={setFieldValue} />
                            </SideDrawerFormContainer>
                        );
                    }}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditCodeStatusSideDrawerContent);
